import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { isNull, get } from 'lodash';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { REQUEST_LAST_ASSIGNED_CLAIMS } from 'containers/ManagerHomePage/constants';
import * as ManagerHomePageActions from 'containers/ManagerHomePage/actions';

export function* requestManagerPendingClaims(action: any) {
  const token = accessTokenStorage.get().token;
  if (isNull(token)) return;
  const path = `/corporeal/common/find-claim`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(get(action.payload, 'searchQuery')),
  };
  yield callApi(
    path,
    [],
    options,
    [],
    ManagerHomePageActions.setLastAssignedClaims,
  );
}

export function* requestManagerPendingClaimsSaga() {
  yield takeLeading(REQUEST_LAST_ASSIGNED_CLAIMS, requestManagerPendingClaims);
}

export default [requestManagerPendingClaimsSaga];
